import { render, staticRenderFns } from "./maldopay.vue?vue&type=template&id=9dc62660"
import script from "./maldopay.vue?vue&type=script&lang=js"
export * from "./maldopay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports